import type { Stripe } from '@stripe/stripe-js';
import { loadStripe } from '@stripe/stripe-js';

class StripeService {
  private static instance: StripeService | null = null;
  private stripeInstance: Stripe | null = null;

  private constructor() {
    this.initStripe();
  }

  public static getInstance(): StripeService {
    if (!StripeService.instance) {
      StripeService.instance = new StripeService();
    }
    return StripeService.instance;
  }

  private async initStripe(): Promise<void> {
    try {
      this.stripeInstance = await loadStripe(
        process.env.REACT_APP_STRIPE_PUBLIC_KEY as string,
      );
    } catch (error) {
      console.error('Error loading Stripe:', error);
    }
  }

  public getStripeInstance(): Stripe | null {
    return this.stripeInstance;
  }
}

export const stripeServiceInstance = StripeService.getInstance();
